const obj2query = (obj) => Object.keys(obj).map((key) => [key, obj[key]]).map((o) => `${o[0]}=${o[1]}`).join('&');

export default obj2query;
